import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../common/table";

class ProgramsTable extends Component {
  columns = [
    {
      path: "name",
      label: "Nombre",
      content: program => <Link to={`/programs/${program._id}`}>{program.name}</Link>
    }
  ];

  deleteColumn = {
    key: "delete",
    content: program => (
      <button
        onClick={() => this.props.onDelete(program)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) this.columns.push(this.deleteColumn);
  }

  render() {
    const { programs, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={programs}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default ProgramsTable;
